<template>
  <div class="order-page-box">
    <div class="order-main">
      <div class="margin-left main-second-bg">
        <!-- 订单中心 -->
        <p class="order-title b-1-cl medium-fonts medium">
          {{ $t("order.index.title") }}
        </p>
        <c-navMenu
          :width="310"
          :navList="navList"
          :navListActive="navListActive"
          @listChange="listChanges"
        />
      </div>
      <div class="margin-right main-second-bg">
        <vue-scroll>
          <div class="margin-right-bar">
            <router-view />
          </div>
        </vue-scroll>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'order',
  data() {
    return {
      navListActive: 'exchangeOrder',
      pageTitleText: null,
    };
  },
  computed: {
    fiatTradeOpen() {
      const base = this.$store.state.baseData.publicInfo;
      if (base && base.switch && base.switch.fiat_trade_open === '1') {
        return true;
      }
      return false;
    },
    publicInfo() {
      return this.$store.state.baseData.publicInfo;
    },
    navList() {
      const arr = [];
      // 合约订单',
      arr.push({
        iconClass: 'iconClass',
        navText: this.$t('order.coOrder.coOrder'),
        href: '',
        type: 1,
        icon: 'coOrderIcon',
        id: 'coOrder',
      });
      // 币币订单
      arr.push({
        iconClass: 'iconClass',
        navText: this.$t('order.index.exOrder'),
        href: '',
        type: 1,
        icon: 'exchangeOrderIcon',
        id: 'exchangeOrder',
      });
      // 法币订单
      arr.push({
        iconClass: 'iconClass',
        navText: !this.fiatTradeOpen
          ? this.$t('order.index.otcOrder')
          : this.$t('assets.b2c.otcShow.otcOrder'),
        href: '',
        type: 1,
        icon: 'otcorder',
        id: 'otcOrder',
      });
      return arr;
    },
    metaText() {
      return this.$route.meta.navName;
    },
  },
  watch: {
    metaText(v) {
      this.navListActive = v;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.navListActive = this.$route.meta.navName;
      if (this.navList.length) {
        this.navList.forEach((item) => {
          if (this.navListActive === item.id) {
            this.pageTitleText = item.navText;
          }
        });
      }
    },
    listChanges(data) {
      this.$router.push(data.id);
      this.navListActive = data.id;
      this.pageTitleText = data.navText;
    },
  },
};
</script>

<style lang="scss" scoped>
.order-page-box {
  height: 100%;
  font-family: 'Medium';

  .order-main {
    min-height: 800px;
    margin: 40px auto;
    box-sizing: border-box;
    position: relative;
    display: flex;
    justify-content: center;
    gap: 24px;
    .margin-left {
      width: 310px;
      min-height: 800px;
      border-radius: 6px;

      .order-title {
        height: 56px;
        line-height: 56px;
        padding-left: 20px;
        font-size: 16px;
      }
    }

    .margin-right {
      width: 966px;
      min-height: 800px;
      border-radius: 6px;
    }
  }
}
</style>
